import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_SUPPLY_CHAIN_INFORMATIONS_KEY } from '@/keys';

type DeleteSupplyChainInformationVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  supplyChainInformationId: string;
  token?: string;
};

async function deleteSupplyChainInformation({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  supplyChainInformationId,
  token,
}: DeleteSupplyChainInformationVariables): Promise<void> {
  await api.delete(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/supply-chain-informations/${supplyChainInformationId}`,
    {
      params: token ? { token } : undefined,
    },
  );
}

export function useDeleteSupplyChainInformation(): UseMutationResult<
  void,
  Error,
  DeleteSupplyChainInformationVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSupplyChainInformation,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_SUPPLY_CHAIN_INFORMATIONS_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.commodityOriginId,
          variables.token ?? '',
        ],
      });
    },
  });
}
